exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nested-content__list{color:#333;font-size:1em;line-height:1.58}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .nested-content__list{color:#fff}}:root[data-theme=dark] .nested-content__list{color:#fff}.nested-content__link{border-bottom:1px solid transparent}.nested-content__link:hover{border-bottom-color:initial}.nested-content__link__bold{font-weight:bold}.nested-content__item{display:flex;flex-direction:row;justify-content:flex-start;align-items:center}@media print{.nested-content{display:none}}\n", ""]);

// exports
exports.locals = {
	"nested-content__list": "nested-content__list",
	"nested-content__link": "nested-content__link",
	"nested-content__link__bold": "nested-content__link__bold",
	"nested-content__item": "nested-content__item",
	"nested-content": "nested-content"
};